import React from 'react';
import { TbBrandGithub }  from "react-icons/tb";
import { SlSocialYoutube, SlSocialLinkedin, SlSocialFacebook, SlSocialInstagram } from "react-icons/sl";

const Footer = () => {
  return (
    <div className='hidden mdl:inline-flex xl:hidden items-center justify-center w-full py-6 gap-4'>
        
    </div>
  )
}

export default Footer